import {Injectable} from '@angular/core';
import {TextSizeEnum} from '../../views/secured/views/modules/display-consent/enums/text-size.enum';

@Injectable()
export class SettingsService {
   addFontClass(value): string {
        switch (value) {
            case TextSizeEnum.SMALL:
                return 'normal';
            case TextSizeEnum.NORMAL:
                return 'medium';
            case TextSizeEnum.LARGE:
                return 'large';
            case TextSizeEnum.EXTRALARGE:
                return 'extra-large';
            default:
                return '';
        }
    }

}
